<template>
  <v-dialog :value="dialogProp.show" persistent max-width="800">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование шаблона торговой процедуры') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <lot-template-edit-info
            ref="lotInfo"
            :lot-template-info="dialogProp.lotTemplate"
            :loading="isLoading"
            :save-method="updateLotTemplateInfo"
            @keydown.native.enter="focusOnBtn('continueBtn')" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            ref="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import LotTemplateEditInfo from '@/components/pages/shared/LotTemplate/LotTemplateEditInfo.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { LOT_TEMPLATE_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      LotTemplateEditInfo
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lotTemplate: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
    },
    methods: {
      ...mapActions(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        updateLotInfoAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.EDIT_LOT_TEMPLATE
      }),
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.lotInfo.validateAndSave()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      updateLotTemplateInfo: async function (lotTemplate) {
        this.isLoading = true
        try {
          await this.updateLotInfoAction({
            lotTemplate,
            lotTemplateId: this.dialogProp.lotTemplate.lotTemplateId,
            lotType: this.dialogProp.lotTemplate.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          //  пробрасываем ошибку чтобы не закрывать диалог
          throw error
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
